module.exports = __webpack_public_path__ + "static/employer-18f7589be9df7e158873616e276f2a61.jpg";